module.exports = __webpack_public_path__ + "static/img/036官网2版3.2bde084.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/036官网2版3.jpg
// module id = yE66
// module chunks = 0